import { TertiaryHeading } from '@ui-components/typography/headings/TertiaryHeading'
import * as React from 'react'
import { styled } from 'styled-components'

import { RemoveItemButton } from '../actions/special/RemoveItemButton'
import { FlexColumnContainer } from '../global/CommonStyling'
import { getIndexedLabel } from '../utilities/textHelpers'

const TertiaryHeadingWithRemoveIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export interface FormRemovableSectionHeaderProps {
  index: number
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  heading: string
  headingDescription?: string
  testID: string
  dynamicArrayLength: number
  removeActionLabel: string
  id?: string
}

export const FormRemovableSectionHeader = ({
  index,
  onClick,
  heading,
  headingDescription,
  testID,
  dynamicArrayLength,
  removeActionLabel,
  id,
}: FormRemovableSectionHeaderProps) => {
  const formattedHeading = getIndexedLabel(heading, index, dynamicArrayLength)
  const ariaLabel = `${removeActionLabel} ${formattedHeading}`
  return (
    <TertiaryHeadingWithRemoveIconContainer>
      <FlexColumnContainer>
        <TertiaryHeading header={formattedHeading} id={id} additionalText={headingDescription} tagName="h2" />
      </FlexColumnContainer>
      {index > 0 && (
        <RemoveItemButton
          type="button"
          data-testid={testID && `${testID}-remove-button`}
          onClick={onClick}
          label={removeActionLabel}
          aria-label={ariaLabel}
        />
      )}
    </TertiaryHeadingWithRemoveIconContainer>
  )
}
